/**
 * Status Badge Component
 * Displays mission status with appropriate colors
 */

import React from 'react';
import { Chip } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { MissionStatus } from '../../types/mission';
import { getStatusColor } from '../../utils/themeHelpers';

interface StatusBadgeProps {
  status: MissionStatus;
}

const getStatusLabel = (status: MissionStatus): string => {
  const labels: Record<MissionStatus, string> = {
    [MissionStatus.PENDING]: 'Pending',
    [MissionStatus.PENDING_ADMIN_REVIEW]: 'Pending Admin Review',
    [MissionStatus.SUBMITTED]: 'Submitted',
    [MissionStatus.GHOST_ASSIGNED]: 'Ghost Assigned',
    [MissionStatus.MISSION_IN_PROGRESS]: 'Mission In Progress',
    [MissionStatus.COMPLETED]: 'Completed',
    [MissionStatus.UNDER_REVIEW]: 'Under Review',
    [MissionStatus.CLOSED]: 'Closed',
    [MissionStatus.CANCELLED]: 'Cancelled',
    [MissionStatus.EXPIRED]: 'Expired',
  };
  return labels[status] || status;
};

export const StatusBadge: React.FC<StatusBadgeProps> = ({ status }) => {
  const theme = useTheme();
  const label = getStatusLabel(status);
  const colors = getStatusColor(status, theme);

  return (
    <Chip
      label={label}
      size="small"
      sx={{
        backgroundColor: colors.backgroundColor,
        color: colors.color,
        fontWeight: theme.typography.button.fontWeight,
        fontSize: theme.typography.caption.fontSize,
        height: 24,
        minWidth: 80,
        '& .MuiChip-label': {
          padding: theme.spacing(0, 1),
        },
      }}
    />
  );
};
